import { useAppDispatch, useAppSelector } from "../../../../redux/store";

import { Button, ChipGroup, ChipMultiGroup, PageHeader, Toolbar } from "../../../../ui";

import { addUser, changeFilter, clearFilters } from "../usersSlice";

const UsersTableControls = () => {
  const dispatch = useAppDispatch();
  const filters = useAppSelector((state) => state.users.filters);

  const handleStatusFilter = (newStatus: string) => {
    dispatch(changeFilter({ name: "status", value: newStatus }));
  };

  const handleRoleFilter = (roles: string[]) => {
    dispatch(changeFilter({ name: "role", value: roles }));
  };

  const handleClearFilters = () => {
    dispatch(clearFilters());
  };

  return (
    <>
      <PageHeader
        eyebrow="Administration"
        title="Users"
        summary="Everyone who can sign in to the portal, and what they can reach."
        actions={
          <Button onClick={() => dispatch(addUser())}>Add new user</Button>
        }
      />
      <Toolbar>
        <ChipGroup
          value={typeof filters.status === "string" ? filters.status : "all"}
          onChange={handleStatusFilter}
          size="sm"
          options={[
            ["all", "All"],
            ["active", "Active"],
            ["inactive", "Inactive"],
            ["deleted", "Deleted"],
            ["pendingActivation", "Pending"],
          ]}
        />
        <ChipMultiGroup
          values={filters.role || []}
          onChange={handleRoleFilter}
          size="sm"
          options={[
            ["admin", "Admin"],
            ["employee", "Employee"],
            ["client", "Client"],
          ]}
        />
        <Button variant="ghost" size="sm" onClick={handleClearFilters}>
          Clear
        </Button>
      </Toolbar>
    </>
  );
};

export default UsersTableControls;
